import { QrCode, QrCodeRootProps } from '@chakra-ui/react'

type QRCodeProps = QrCodeRootProps

export const QRCode = (props: QRCodeProps) => {
  return (
    <QrCode.Root {...props}>
      <QrCode.Frame>
        <QrCode.Pattern />
      </QrCode.Frame>
    </QrCode.Root>
  )
}
